import { useEffect, useRef, type ReactNode } from "react";

type SheetProps = {
  title?: string;
  description?: string;
  onClose: () => void;
  children: ReactNode;
};

/** Bottom sheet on phones, centred dialog on wider screens. */
export function Sheet({ title, description, onClose, children }: SheetProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    // Move focus into the sheet so the dialog is reachable by keyboard alone.
    ref.current?.querySelector<HTMLElement>("input, button, textarea")?.focus();
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <div
      className="sheet-backdrop"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="sheet" role="dialog" aria-modal="true" aria-label={title} ref={ref}>
        {title ? <h2>{title}</h2> : null}
        {description ? <p>{description}</p> : null}
        {children}
      </div>
    </div>
  );
}
